import React from 'react';
import { object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import Trigger from '../../../shared/FirstMessagePopup/Trigger';
import { reportContactSellerClick } from '../../../../utils/contactSeller';

import './style.scss';

const ContactMe = (props, { biEvents, general }) => {

    const reportContactMeClick = () => reportContactSellerClick({
        biEvents,
        general,
        mixpanelSourceComponent: 'Gig page seller card',
        bqSourceName: 'about_the_seller',
        metricKey: 'contact_me.click'
    });

    const shouldShowContact = () => {
        const { isOnVacation } = general;
        return !isOnVacation;
    };

    if (!shouldShowContact()) {
        return null;
    }

    return (
        <Trigger onClick={reportContactMeClick} className="btn-contact-me">
            <I18n k={'gig_page_perseus.seller_card.contact_me'}/>
        </Trigger>
    );
};

ContactMe.contextTypes = {
    biEvents: object,
    general: object
};

export default ContactMe;
